import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { FooterMenuWrapper, FooterList, FooterItem, Link, ImageWrapper } from './menu-footer.styles';

const MenuFooter = ({
  data,
  onMenuFooterClick
}) => {
  const {
    linksList
  } = data;
  return /*#__PURE__*/React.createElement(FooterMenuWrapper, {
    "data-testid": "header-menu-footer-elem"
  }, linksList ? /*#__PURE__*/React.createElement(FooterList, null, linksList.map((link, index) => /*#__PURE__*/React.createElement(FooterItem, {
    key: `footer-item-${index}`
  }, link.img && link.img.component && /*#__PURE__*/React.createElement(ImageWrapper, {
    "data-testid": "image-elem",
    width: link.img.width
  }, link.img.component), /*#__PURE__*/React.createElement(Link, {
    onClick: e => onMenuFooterClick(e, link),
    href: link.url,
    px: 2
  }, link.label)))) : /*#__PURE__*/React.createElement(React.Fragment, null));
};

MenuFooter.defaultProps = {
  data: {},
  onMenuFooterClick: () => ({})
};
process.env.NODE_ENV !== "production" ? MenuFooter.propTypes = {
  data: shape({
    linksList: arrayOf(shape({
      url: string,
      label: string,
      img: shape({
        path: string,
        width: number
      })
    }))
  }),
  onMenuFooterClick: func
} : void 0;
export default MenuFooter;